import React, { useState, useEffect } from 'react';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Admin from './pages/Admin';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import ResetPassword from './pages/ResetPassword';
import GoogleRegister from './pages/GoogleRegister';
import ProfessionalDashboard from './pages/ProfessionalDashboard';
import axios from 'axios';

const API_URL = 'https://casetrackus.com';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const path = window.location.pathname;

  useEffect(() => {
    if (path === '/terms' || path === '/privacy' || path === '/reset-password' || path === '/google-register') {
      setLoading(false);
      return;
    }
    const init = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const urlToken = urlParams.get('token');
      if (urlToken) {
        localStorage.setItem('token', urlToken);
        window.history.replaceState({}, document.title, '/');
        try {
          const res = await axios.get(`${API_URL}/auth/me?token=${urlToken}`);
          const userData = res.data;
          localStorage.setItem('user', JSON.stringify(userData));
          setUser(userData);
        } catch (err) {
          localStorage.removeItem('token');
        }
        setLoading(false);
        return;
      }
      const savedUser = localStorage.getItem('user');
      const token = localStorage.getItem('token');
      if (savedUser && token) {
        setUser(JSON.parse(savedUser));
      }
      setLoading(false);
    };
    init();
  }, [path]);

  const handleLogin = (userData) => setUser(userData);
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  if (path === '/terms') return <Terms />;
  if (path === '/privacy') return <Privacy />;
  if (path === '/reset-password') return <ResetPassword />;
  if (path === '/google-register') return <GoogleRegister onLogin={handleLogin} />;
  if (loading) return null;

  return (
    <div>
      {user ? (
        user.is_admin
          ? <Admin user={user} onLogout={handleLogout} />
          : user.account_type === 'professional'
            ? <ProfessionalDashboard user={user} onLogout={handleLogout} />
            : <Dashboard user={user} onLogout={handleLogout} />
      ) : (
        <Login onLogin={handleLogin} />
      )}
    </div>
  );
}

export default App;
